import React from "react";

const extractNodeText = (node) => {
	if (node === null || node === undefined || typeof node === "boolean") {
		return "";
	}

	if (typeof node === "string" || typeof node === "number") {
		return String(node);
	}

	if (Array.isArray(node)) {
		return node.map(extractNodeText).join("");
	}

	if (React.isValidElement(node)) {
		return extractNodeText(node.props?.children);
	}

	return "";
};

export const getSelectOptionText = (option) => {
	if (!option || typeof option !== "object") {
		return "";
	}

	const candidates = [option.label, option.children, option.value];

	for (const candidate of candidates) {
		if (candidate === null || candidate === undefined) {
			continue;
		}

		const text = extractNodeText(candidate);
		if (text !== "") {
			return text;
		}
	}

	return "";
};

const normalizeText = (value) => value.toLowerCase();

export const filterSelectOption = (input, option) =>
	normalizeText(getSelectOptionText(option)).includes(normalizeText(String(input ?? "")));

export const sortSelectOptions = (optionA, optionB) =>
	normalizeText(getSelectOptionText(optionA)).localeCompare(normalizeText(getSelectOptionText(optionB)));
